import type { ActionData } from '@bringg/types';

export enum ENVIRONMENT {
	DEVELOPMENT = 'development',
	PRODUCTION = 'production',
	TEST = 'test'
}

export interface WayPointLocation {
	location: google.maps.LatLng;
	wayPointPosition: number;
	id: number;
}

export interface ActionsConfiguration {
	id?: number;
	title?: string;
	action_data?: ActionData[];
	enable_automated_action_flow?: boolean;
}

export enum ActionsConfigurationLevel {
	USER = 'ACTION_CONFIGURATION.USER_LEVEL',
	ORDER = 'ACTION_CONFIGURATION.TASK_LEVEL',
	INVENTORY = 'ACTION_CONFIGURATION.INVENTORY_LEVEL',
	SHIFT = 'ACTION_CONFIGURATION.SHIFT_LEVEL'
}

export enum ActionsConfigurationAtomationFlow {
	YES = 'GLOBAL.YES',
	NO = 'GLOBAL.NO',
	UNSET = 'ACTION_CONFIGURATION.AUTOMATED_ACTION_FLOW.UNSET'
}

export enum ActionDataType {
	QUESTION = 'Question',
	ACTION_FORM = 'Action form',
	REJECT_INVENTORY = 'Reject inventory',
	TAKE_NOTE = 'Take note',
	TAKE_SIGNATURE = 'Take signature',
	TAKE_PICTURE = 'Take picture',
	TAKE_SCAN = 'Take scan',
	CANCEL_TASK = 'Cancel task',
	OPEN_IFRAME = 'Open webpage',
	VERIFICATION_PIN_CODE = 'Verification PIN Code',
	ADD_WAYPOINT = 'Add waypoint',
	ADD_ORDER = 'Add order'
}

export interface IFilterOption<T> {
	value: T;
	title: string;
}

// TODO: move to @bringg/types
export type OptionalBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;
export type RequiredBy<T, K extends keyof T> = Omit<T, K> & Required<Pick<T, K>>;

export type UnwrapArray<T> = T extends Array<infer U> ? U : never;
